module.exports = __webpack_public_path__ + "download_appstore.svg?2543b52ebb365ba7de77b4a236cd7898";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/download_appstore.svg
// module id = 1226
// module chunks = 6